<template>
	<div >
		<div v-for="(l,index) in  videolist" :key="index">
			<video src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/phvideosimg/喷砂机中文宣传片.mp4" width="800" height="400" :id="'video'+l.title" controls="controls" ></video>
			<button class="play" @click="playc(l.title)">播放</button>
			<button class="close"@click="close(l.title)">暂停</button>
		</div>
	</div>
 
</template>
<script>
/* import { videoPlayer } from "vue-video-player";
require("video.js/dist/video-js.css");
require("vue-video-player/src/custom-theme.css"); */

export default {
  data() {
    return {
      videolist: [
       // { title: 1, movie: require("https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/phvideosimg/喷砂机中文宣传片.mp4") },
       //  { title: 2, movie: require("https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/phvideosimg/喷砂机中文宣传片.mp4") },
       //  { title: 3, movie: require("https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/phvideosimg/喷砂机中文宣传片.mp4")},
       //  { title: 4, movie: require("https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/phvideosimg/喷砂机中文宣传片.mp4") }
      ],
      playsinline: true,
      playerOptions: [],
      options: ""
    };
  },
  created() {
	  window.scrollTo(0,0);
    this.getMovieList();
  },

  methods: {
	  close(){
		  
	var video=document.getElementById("video");
		  video.pause();
	  },
	  playc(e){
		  for(let l =0; l<this.videolist.length;l++){
			  if(e==this.videolist[l].title){
				  
				let id=document.getElementById(`video${this.videolist[l].title}`)
				id.play();
			  }else{
				  let id=document.getElementById(`video${this.videolist[l].title}`)
				  id.pause();
			  }
			 
		  }
		 /* this.bigpcproductticont.map( (i) => {
		  	
		    id = document.getElementById(`video${i.product_id}`);
		   let  mianscrollHeight = id.scrollHeight;
		    var mianoffsetTop = id.offsetTop;
		    // 页面滚动位置 > 元素距离顶部高度-窗口高度 && 页面滚动位置 < 元素距离顶部高度+元素本身高度
		    if (scroll > mianoffsetTop  - 200) {
		     
		  	for(let l=0;l<this.bigpcproductticont.length;l++){
		  		if(this.bigpcproductticont[l].product_id==i.product_id){
		  			
		  			this.bigpcproductticont[l].mess1=true
		  		}
		  	}
		    } else {
		    
		    }
		  }); */
		  /* id = document.getElementById(`id${i.product_id}`);
			var video=document.getElementById("video"); */

		 /* video.play(); */
	  },
	cccc(e){
		console.log(e) 
	},
    getMovieList() {
    // 这里正常来说应该是从后台获取的数据，以下操作都是在成功的回调函数里
      for (var i = 0; i < this.videolist.length; i++) {
          let arrs = {
            playbackRates: [1.0, 2.0, 3.0], //播放速度
            autoplay: false, //如果true,浏览器准备好时开始回放。
            muted: false, // 默认情况下将会消除任何音频。
            loop: false, // 导致视频一结束就重新开始。
            preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
            language: "zh-CN",
            aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
            fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
            sources: [
              {
                type: "video/mp4",
                type: "video/ogg",
                src: this.videolist[i].movie //url地址
              }
            ],
            poster: "", //封面地址
            notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
            controlBar: {
              timeDivider: true,
              durationDisplay: true,
              remainingTimeDisplay: false,
              fullscreenToggle: true //全屏按钮
            }
          };
          this.playerOptions.push(arrs);
        }
    },
    onPlayerPlay(player, index) {
 
      
       var that = this.$refs.videoPlayer;
       for (let i = 0; i < that.length; i++) {
          if(i != index)
          that[i].player.pause()
       }
    },
    onPlayerPause(player) {

      
    }
  }
};
</script>
<style >
.mui-table-view {
  
  
  
}
.mui-table-view h1 {
    font-size: 14px;
    line-height: 24px;
    text-indent: 2em;
  }
 .mui-table-view .mui-ellipsis {
    font-size: 14px;
    color: #226aff;
    display: flex;
    justify-content: space-between;
    margin: 5px 0;
  }
 .mui-table-view video {
    width: 100%;
    height: 300px;
  }
  
  .video-js .vjs-control-bar button{
    outline: none;
  }
</style>
